import PodUpload from './styled';

export default PodUpload;
